module.exports = __webpack_public_path__ + "static/media/1920-service-2-5-min.40a6af4b.jpg";